import { Helmet } from "react-helmet";
import { DashboardLayout } from "../../../../components/layouts/DashboardLayout";
import { Header } from "../../../../components/Header";
import { useState } from "react";
import {
  FaEye,
  FaPenToSquare,
  FaTrashCan,
  FaNetworkWired,
  FaCircleUser,
  FaHashtag,
  FaCircleNodes,
  FaServer,
} from "react-icons/fa6";
import { BtnDefault } from "../../../../components/buttons/BtnDefault";
import { useHookPop } from "../../../../hooks/useHookPop";
import { useNavigate } from "react-router-dom";
import { OltMobileActionBtn } from "./components/OltMobileActionButton";
import { OltActionBtn } from "./components/OltActionButton";
import { useHookOlt } from "../../../../hooks/useHookOlt";
import { OltTable } from "./sections/table";
import { MasterDataStatusBadge } from "../../../../components/badge/MasterDataStatusBadge";
import { OltMobileList } from "./sections/mobile_list";
import { ConfirmDeleteOlt } from "./modal/confirm_delete";

export const Olt = () => {
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(true);
  const [openModalCreate, setOpenModalCreate] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [keyword, setKeyword] = useState("");

  const { data, loading, refreshData, setParams } = useHookOlt();

  return (
    <>
      <Helmet>
        <title>Management Olt - Radius Trend</title>
        <meta
          name="description"
          content="Kelola data Olt — pantau port, jumlah POP/ODC/ODP, dan user PPPoE yang terhubung ke setiap OLT."
        />
      </Helmet>

      <DashboardLayout showSidebar={showSidebar} setShowSidebar={setShowSidebar}>
        {/* ===== Header ===== */}
        <Header toggleSidebar={() => setShowSidebar(!showSidebar)}>
          <h2 className="text-base md:text-xl font-display font-bold text-gray-100">
            Management OLT
          </h2>
          <BtnDefault onClick={() => navigate("/dashboard/master-data/olt/create")}>
            <span className="hidden sm:inline">Tambah OLT</span>
            <span className="sm:hidden">Tambah</span>
          </BtnDefault>
        </Header>

        {/* ===== Content ===== */}
        <main className="p-4 lg:p-6 space-y-5">
          {/* ===== Search ===== */}
          <section
            className="rounded-2xl p-4"
            style={{
              background: "rgba(15, 23, 42, 0.5)",
              border: "1px solid rgba(51, 65, 85, 0.3)",
              backdropFilter: "blur(12px)",
            }}
            aria-label="Pencarian Olt"
          >
            <div className="w-full max-w-sm">
              <div className="relative">
                <i
                  className="fa-solid fa-magnifying-glass absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500 text-sm"
                  aria-hidden="true"
                />
                <input
                  type="text"
                  placeholder="Cari nama Olt..."
                  value={keyword}
                  onChange={(e) => {
                    setKeyword(e.target.value);
                    setParams({ keyword: e.target.value });
                  }}
                  className="w-full pl-10 pr-4 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 placeholder-slate-500 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all"
                />
              </div>
            </div>
          </section>

          {/* ===== Desktop Table ===== */}
          <OltTable
            data={data}
            loading={loading}
            keyword={keyword}
            setOpenDeleteModal={setOpenModalDelete}
            setDeleteId={setDeleteId}
          />


          {/* ===== Mobile Cards ===== */}
          <OltMobileList data={data} loading={loading} keyword={keyword} />

        </main>
      </DashboardLayout>

      {/* ===== Modal Delete ===== */}
      <ConfirmDeleteOlt
        openModal={openModalDelete}
        setOpenModal={setOpenModalDelete}
        id={deleteId}
        refresh={refreshData}
      />
    </>
  );
};